/**
 * VerifyPersonalEmailPage — confirmation de l'email personnel de
 * récupération depuis le lien reçu par email.
 */
import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2, ShieldCheck } from 'lucide-react';
import api from '../../lib/api';

export default function VerifyPersonalEmailPage() {
    const [params] = useSearchParams();
    const [state, setState] = useState('loading');
    const [detail, setDetail] = useState('');

    useEffect(() => {
        const token = params.get('token');
        if (!token) { setState('error'); setDetail('Lien invalide.'); return; }
        api.post('/auth/verify-personal-email', { token })
            .then((r) => { setState('ok'); setDetail(r.data.email); })
            .catch((e) => {
                setState('error');
                setDetail(e.response?.data?.detail || 'Lien invalide ou expiré.');
            });
    }, [params]);

    return (
        <div className="min-h-screen flex items-center justify-center px-4"
             style={{ background: 'linear-gradient(135deg, #681793 0%, #FF914D 100%)' }}
             data-testid="verify-personal-email-page">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 text-center">
                <div className="flex justify-center mb-4">
                    <ShieldCheck className="w-10 h-10" style={{ color: '#681793' }} />
                </div>
                {state === 'loading' && (
                    <>
                        <Loader2 className="w-6 h-6 animate-spin mx-auto mb-3" style={{ color: '#681793' }} />
                        <p className="text-gray-600">Vérification en cours…</p>
                    </>
                )}
                {state === 'ok' && (
                    <>
                        <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-3" />
                        <h1 className="text-xl font-extrabold text-gray-900 mb-2">Email personnel confirmé</h1>
                        <p className="text-gray-600 text-sm mb-6">
                            <span className="font-semibold">{detail}</span> est désormais
                            l'adresse de récupération de votre compte Homly. Vous pouvez
                            aussi l'utiliser pour vous connecter.
                        </p>
                        <Link to="/login" data-testid="verify-personal-email-login-link"
                              className="inline-block px-8 py-3 rounded-xl font-bold text-white"
                              style={{ background: 'linear-gradient(135deg, #681793 0%, #FF914D 100%)' }}>
                            Se connecter
                        </Link>
                    </>
                )}
                {state === 'error' && (
                    <>
                        <XCircle className="w-12 h-12 text-red-500 mx-auto mb-3" />
                        <h1 className="text-xl font-extrabold text-gray-900 mb-2">Lien invalide</h1>
                        <p className="text-gray-600 text-sm mb-6">{detail}</p>
                        <Link to="/login" className="text-sm font-semibold" style={{ color: '#681793' }}>
                            Retour à la connexion
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
